import { AutocompleteRenderGroupParams } from '@mui/material/Autocomplete/Autocomplete'
import { TertiaryIconButton } from '../../../custom-button/CustomButton'
import { Typography } from '@mui/material'
import { CloseIcon } from '../../../icons'
import { useBreakpoints } from '@obeta/data/lib/hooks/useBreakpoints'
import styles from './AutocompleteGroup.module.scss'
import { useMemo } from 'react'

export type AutocompleteGroupProps = {
  group: AutocompleteRenderGroupParams
  onClose?: () => void
}

export const AutocompleteGroup = (props: AutocompleteGroupProps) => {
  const { group, onClose } = props
  const { mobile, tablet } = useBreakpoints()

  const renderButton = useMemo(() => {
    const firstGroup = group.key === 0
    const isMobile = mobile || tablet
    return firstGroup && isMobile
  }, [group, mobile, tablet])

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Typography variant="bodyBold">{group.group}</Typography>
        {renderButton && (
          <TertiaryIconButton icon={<CloseIcon />} onClick={onClose} className={styles.button} />
        )}
      </div>
      <div className={styles.items}>{group.children}</div>
    </div>
  )
}
